import NotificationMenu from "../components/notifications/notificationMenu";
import PageWrapper from "../components/pageWrapper";

function Notifications() {

    return  (
    <PageWrapper>
    <NotificationMenu/>
    </PageWrapper>

    );
  };

  export default Notifications;